module.exports = "/assets/hero-xmas-sm.png?EGEFq/N";